/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getTarjetasBancos, getTarjetaBanco } from "../../services/TarjetaBancoService";
import Message from "../../utils/Message";
import TarjetaBancoDialog from "./TarjetaBancoDialog";
import { getTarjetas } from "../../services/TarjetaService";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  bancoEntidad: "",
  idTarjeta: "",
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Tarjetas - Bancos";
//
// #############################################################################
//
const TarjetaBancoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [valueACTarjeta, setValueACTarjeta] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACTarjeta,
    setInputValueACTarjeta] = useState("");
  const [tarjetas, setTarjetas] = useState([]);

  const { hasPermission } = useContext(AuthContext);
  const _crearTarjetaBanco = hasPermission("tarjeta-banco-c");
  const _editarTarjetaBanco = hasPermission("tarjeta-banco-e");
  const _habilitarTarjetaBanco = hasPermission("tarjeta-banco-h");
  const _deshabilitarTarjetaBanco = hasPermission("tarjeta-banco-d");

  const tableColumns = [
    {
      field: "marca_tarjeta",
      headerName: "Tarjeta",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.marca_tarjeta;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tipo_tarjeta",
      headerName: "Tipo",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tipo_tarjeta;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "banco_entidad",
      headerName: "Banco / Entidad",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.banco_entidad;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_odoo",
      headerName: "Código Odoo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_odoo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarTarjetaBanco && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarTarjetaBanco && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarTarjetaBanco && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  // cuando cambia la pagina actual o la cantidad de filas por pagina
  //
  useEffect(() => {
    load();
    loadTarjetas();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setCurrentPage(0);
    setSearchData(initialSearchData);
    setItemsCrud([]);
    setValueACTarjeta({
      id: "",
      descripcion: "",
    });

  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      bancoEntidad: searchData.bancoEntidad,
      idTarjeta: searchData.idTarjeta,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getTarjetasBancos(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      setTotalRowsCount(response.data.count);
      setItemsCrud(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    let _itemCrud = {};

    if (action !== "new") {
      const loadItem = async () => {
        setIsDoingSomething(true);
        const response = await getTarjetaBanco({ id: itemCrud.id });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data[0];
          _itemCrud = {
            id: _response.id,
            bancoEntidad: _response.banco_entidad,
            descripcionOdoo: _response.descripcion_odoo,
            observaciones: _response.observaciones,
            tarjeta: {
              id: _response.id_tarjeta,
              label: (_response.marca_tarjeta).toUpperCase() + " - " + (_response.tipo_tarjeta).toUpperCase(),
            }
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialog(true);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
    }
  };

  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };

  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  //
  // ################################################################################
  // habilito Enter en campos de texto para buscar

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };

  //
  // ################################################################################
  //
  const loadTarjetas = async () => {
    const response = await getTarjetas();
    if (response.ok) {

      let _response = response.data.data
      setTarjetas(_response);
      setValueACTarjeta({
        id: "",
        descripcion: "",
      });
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }


  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tarjeta"
                  size="small"
                  value={valueACTarjeta && valueACTarjeta.id ? valueACTarjeta : null}
                  onChange={(event, newValue) => {
                    setValueACTarjeta(newValue);
                    setSearchData({
                      ...searchData,
                      idTarjeta: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACTarjeta}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACTarjeta(newInputValue);
                  }}
                  options={tarjetas}
                  getOptionLabel={(option) => (option.marca).toUpperCase() + " - " + (option.tipo).toUpperCase()}
                  renderInput={(params) => (
                    <TextField {...params} label="Tarjeta" />
                  )}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="bancoEntidad"
                  label="Banco / Entidad"
                  variant="outlined"
                  size="small"
                  name="bancoEntidad"
                  value={searchData.bancoEntidad}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-documento-select-label">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearTarjetaBanco && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nueva tarjeta / banco">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nueva
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <TarjetaBancoDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TarjetaBancoTable;
